import React, {
  useContext, useReducer, useEffect, useState, 
 } from 'react';
 import { Field, Form } from 'react-final-form';
 import { useSelector } from 'react-redux';
 import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
 import PropTypes from 'prop-types';
 import {
   Alert, Spinner, Button,
 } from 'react-bootstrap';
 import PasswordField from '@/shared/components/form/Password';
 import { renderMaskedField } from '@/shared/components/form/FormField';
 import { AiOutlineNumber } from 'react-icons/ai';
 import { useHistory, Link } from 'react-router-dom';
 import {
   FormGroup,
   FormGroupField,
   FormGroupIcon,
   FormGroupLabel,
 } from '@/shared/components/form/FormElements';
 import { AccountButton, Forgote, AccountForgotPassword } from '../AccountElements';
import { GlobalContext } from '../../../../context/GlobalContext';

 // Initial state for the reducer
 const initialState = {
   isEmailValidate: false,
   isOTPValidate: false,
   isLoading: false,
   errorMsg: '',
   successMessage: '',
   validationError: null,
   timer: 300, // 2 minutes in seconds
 };
 
 // Reducer function to handle actions
 const reducer = (state, action) => {
   switch (action.type) {
     case 'SET_LOADING':
       return { ...state, isLoading: action.payload };
     case 'SET_ERROR':
       return { ...state, errorMsg: action.payload };
     case 'SET_SUCCESS':
       return { ...state, successMessage: action.payload };
     case 'SET_VALIDATION_ERROR':
       return { ...state, validationError: action.payload };
     case 'SET_VALIDATE_STATUS':
       return { ...state, isEmailValidate: action.payload };
     case 'SET_OTP_STATUS':
       return { ...state, isOTPValidate: action.payload };
     case 'SET_TIMER':
       return { ...state, timer: action.payload };
     default:
       return state;
   }
 };
 
 const Forgot = ({
   errorMessage,
   fieldUser,
   typeFieldUser,
 }) => {
   const errorMsg = useSelector(state => state.user.error);
   const [state, dispatch] = useReducer(reducer, initialState);
   const {
     isEmailValidate, isOTPValidate, isLoading, validationError, successMessage, timer,
   } = state;
   const { apiGlobal } = useContext(GlobalContext);
   const history = useHistory();
   
   // Start timer when email is validated
   useEffect(() => {
     let interval;
     if (isEmailValidate && !isOTPValidate && timer > 0) {
       interval = setInterval(() => {
         dispatch({ type: 'SET_TIMER', payload: timer - 1 });
       }, 1000);
     } else if (timer === 0 && isEmailValidate && !isOTPValidate) {
       // Redirect to login page when timer reaches 0
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'OTP verification timeout. Please try again.' });
       setTimeout(() => {
         history.push('/');
       }, 5000);
     }
     
     return () => clearInterval(interval);
   }, [timer, isEmailValidate, isOTPValidate, history]);
 
   // Format timer display
   const formatTime = (time) => {
     const minutes = Math.floor(time / 60);
     const seconds = time % 60;
     return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
   };
 
   // Validate username
   const validateUsername = async (email) => {
     dispatch({ type: 'SET_LOADING', payload: true });
  
 
     const formdata = new FormData();
     formdata.append('type', 1);
     formdata.append('email', email);
 
     try {
       const response = await fetch(`${apiGlobal}/agent/otp_generator_agent.php`, {
         method: 'POST',
         body: formdata,
       });
       const result = await response.json();
       console.log(result);
       if (result.status && result.message === 'Success' && result.success) {
         dispatch({ type: 'SET_VALIDATE_STATUS', payload: true });
         dispatch({
  type: 'SET_SUCCESS', 
           payload: 'Email validated successfully. Please enter the OTP sent to your email.', 
 });
       } else {
         dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'Email not found.' });
       }
     } catch (error) {
       console.log(error);
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'An error occurred. Please try again.' });
     } finally {
       dispatch({ type: 'SET_LOADING', payload: false });
     }
   };
 
   // Validate OTP
   const validateOTP = async (email, otp) => {
     console.log(email, otp);
     dispatch({ type: 'SET_LOADING', payload: true });
     const formData = new FormData();
     formData.append('type', 1);
     formData.append('email', email);
      formData.append('otp', otp);
     try {
       const response = await fetch(`${apiGlobal}/agent/forgot_pass.php`, {
        method: 'POST',
        body: formData,
       });
       const result = await response.json();
       console.log(result);
       if (result.status && result.message === 'Success' && result.success) {
         dispatch({ type: 'SET_OTP_STATUS', payload: true });
         dispatch({ type: 'SET_SUCCESS', payload: 'OTP verified successfully. Please reset your password.' });
       } else {
         dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'Invalid OTP. Please try again.' });
       }
     } catch (error) {
       console.log(error);
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'An error occurred while verifying OTP. Please try again.' });
     } finally {
       dispatch({ type: 'SET_LOADING', payload: false });
     }
   };
 
   // Navigate to login page
   const handleNavigate = () => {
     history.push('/');
   };
 
   const handlePasswordReset = async (values) => {
    console.log(JSON.stringify(values, null, 2));
 
     // If OTP validation hasn't happened yet, validate OTP first
     if (isEmailValidate && !isOTPValidate && values.otp) {
       validateOTP(values.username, values.otp);
       return;
     }
     
     // Password reset logic
     if (!values.password || !values.confirmPassword) {
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'Please enter both password fields.' });
       return;
     }
     
     if (values.password !== values.confirmPassword) {
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'Passwords do not match.' });
       return;
     }
     
     if (values.password.length < 6) {
       dispatch({ type: 'SET_VALIDATION_ERROR', payload: 'Password must be at least 6 characters long.' });
       return;
     }
   
     dispatch({ type: 'SET_LOADING', payload: true });

     const formData = new FormData();
     formData.append('type', 2);
     formData.append('email', values.username);
     formData.append('password', values.confirmPassword);
   
     try {
       const response = await 
       fetch(`${apiGlobal}/agent/forgot_pass.php`, {
        method: 'POST',
        body: formData,
       });
       if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
       }
       const result = await response.json();
       console.log(result);
       if (result.status && result.message === 'Success' && result.success) {
         dispatch({ type: 'SET_SUCCESS', payload: 'Password Reset Successfully.' });
         setTimeout(() => {
           handleNavigate();
         }, 2000);
       } else {
         dispatch({ type: 'SET_ERROR', payload: result.message || 'Failed to reset password.' });
       }
     } catch (error) {
       console.log('Error occurred during password reset:', error);
       dispatch({ type: 'SET_ERROR', payload: 'An error occurred while resetting the password. Please try again.' });
     } finally {
       dispatch({ type: 'SET_LOADING', payload: false });
     }
   };
 
   return (
     <div>
       <Form
         onSubmit={handlePasswordReset}
         render={({ handleSubmit, values }) => (
           <Forgote onSubmit={handleSubmit}>
             <Alert
               variant="danger"
               show={!!errorMessage || !!validationError}
               dismissible
               onClose={() => { dispatch({ type: 'SET_VALIDATION_ERROR', payload: null }); }}
             >
               {validationError || errorMessage}
             </Alert>
 
             <Alert
               variant="success"
               show={!!successMessage}
               dismissible
               onClose={() => { dispatch({ type: 'SET_SUCCESS', payload: null }); }}
             >
               {successMessage}
             </Alert>
 
             <FormGroup>
               <FormGroupLabel>{fieldUser}</FormGroupLabel>
               <FormGroupField>
                 <FormGroupIcon>
                   <AccountOutlineIcon />
                 </FormGroupIcon>
                 <Field
                   name="username"
                   component="input"
                   type="text"
                   placeholder={fieldUser}
                   // className="input-without-border-radius"
                   required
                   readOnly={isEmailValidate}
                 />
               </FormGroupField>
             </FormGroup>
             
             {!isEmailValidate && (
               <AccountButton
                 variant="primary"
                 type="button"
                 disabled={isLoading || !values.username}
                 style={{ marginTop: '10px' }}
                 onClick={() => validateUsername(values.username)}
               >
                 {isLoading ? <Spinner animation="border" size="sm" /> : 'Validate Email'}
               </AccountButton>
             )}
 
             {isEmailValidate && !isOTPValidate && (
               <>
                 <FormGroup style={{ marginTop: '20px' }}>
                   <FormGroupLabel>
                     Enter 6 Digit OTP 
                     <span style={{ color: timer <= 30 ? 'red' : 'green', marginLeft: '10px', fontWeight: 'bold' }}>
                       Time remaining: {formatTime(timer)}
                     </span>
                   </FormGroupLabel>
                   <FormGroupField>
                     <FormGroupIcon>
                       <AiOutlineNumber />
                     </FormGroupIcon>
                     <Field
                       name="otp"
                       component={renderMaskedField}
                       mask={[/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                       placeholder="Enter 6 Digit OTP"
                       className="input-without-border-radius"
                       required
                     />
                   </FormGroupField>
                 </FormGroup>
 
                 <AccountButton
                   variant="primary"
                   type="submit"
                   disabled={isLoading || !values.otp}
                   style={{ marginTop: '10px' }}
                 >
                   {isLoading ? <Spinner animation="border" size="sm" /> : 'Verify OTP'}
                 </AccountButton>
               </>
             )}
 
             {isEmailValidate && isOTPValidate && (
               <>
                 <FormGroup style={{ marginTop: '20px' }}>
                   <FormGroupLabel>New Password</FormGroupLabel>
                   <FormGroupField>
                     <FormGroupIcon>
                       <AccountOutlineIcon />
                     </FormGroupIcon>
                     <Field
                       name="password"
                       component={PasswordField}
                       placeholder="Enter New Password"
                       className="input-without-border-radius"
                       validate={(value) => {
                         if (!value) return 'Password is required';
                         if (value.length < 6) return 'Password must be at least 6 characters long';
                         return undefined;
                       }}
                       required
                     />
                   </FormGroupField>
                 </FormGroup>
 
                 <FormGroup>
                   <FormGroupLabel>Confirm Password</FormGroupLabel>
                   <FormGroupField>
                     <FormGroupIcon>
                       <AccountOutlineIcon />
                     </FormGroupIcon>
                     <Field
                       name="confirmPassword"
                       component={PasswordField}
                       placeholder="Confirm Password"
                       className="input-without-border-radius"
                       validate={(value, allValues) => {
                         if (!value) return 'Confirm Password is required';
                         if (value !== allValues.password) return 'Passwords do not match';
                         return undefined;
                       }}
                       required
                     />
                   </FormGroupField>
                 </FormGroup>
 
                 <AccountButton
                   variant="primary"
                   type="submit"
                   disabled={isLoading}
                   style={{ marginTop: '10px' }}
                 >
                   {isLoading ? <Spinner animation="border" size="sm" /> : 'Reset Password'}
                 </AccountButton>
               </>
             )}
           </Forgote>
         )}
       />
       <div>
         <Link
           to="/login"
           style={{
             fontSize: '16px',
             height: '50px',
             width: '100px',
             textAlign: 'center',
             textDecoration: 'none',
             borderRadius: '5px',
           }}
         >
           Back to Log In
         </Link>
       </div>
     </div>
   );
 };
 
 Forgot.propTypes = {
   errorMessage: PropTypes.string,
   fieldUser: PropTypes.string,
   typeFieldUser: PropTypes.string,
 };
 
 Forgot.defaultProps = {
   errorMessage: '',
   fieldUser: 'Username',
   typeFieldUser: 'text',
 };
 
 export default Forgot;
 
